import Vue from 'vue';
import { parseInvoiceFile } from '@/utils/invoice';
import _ from 'lodash';
import * as types from './mutation-types';

export default {
  [types.UPDATE_APP_DIRECTORY](state, payload) {
    state.appDirectory = payload;
  },
  [types.INVOICE_CHECK_ITEM_CHANGED](state, payload) {
    const { id, isSelected } = payload;
    const selectedInvoices = new Set([...state.selectedInvoices]);
    if (isSelected) {
      selectedInvoices.add(id);
    } else {
      selectedInvoices.delete(id);
    }
    state.selectedInvoices = selectedInvoices;
    state.checkAll = state.selectedInvoices.size === state.invoiceList.length;
  },
  [types.RESET_CHECK_INVOICE](state) {
    state.selectedInvoices = [];
    state.checkAll = state.selectedInvoices.size === state.invoiceList.length;
  },
  [types.GET_DETAILS_INVOICE](state, payload) {
    const { id, content } = payload;
    if (!state.detailsInvoice.has(id) || state.detailsInvoice.get(id) !== content) {
      const newMap = new Map(state.detailsInvoice);
      newMap.set(id, content);
      state.detailsInvoice = newMap;
    }
  },
  [types.GET_INVOICES_ISSUING](state, payload) {
    const { invoices_list: invoices, statistic } = payload;
    state.invoiceList = invoices;
    state.lastFetchedInvoiceList = invoices;
    state.statusStatistic = {
      draft: statistic.draf,
      issuing: statistic.releasing,
      failed: statistic.release_error,
    };
  },
  [types.GET_INVOICES](state, payload) {
    state.invoiceList = payload;
    state.lastFetchedInvoiceList = payload;
  },
  [types.GET_CUSTOMERS](state, payload) {
    state.customerList = payload;
    state.lastFetchedCustomerList = payload;
  },
  [types.GET_VENDORS](state, payload) {
    state.vendorList = payload;
    state.lastFetchedVendorList = payload;
  },
  [types.LOAD_MORE_INVOICES](state, payload) {
    const invoiceList = [...state.lastFetchedInvoiceList, ...payload];
    state.invoiceList = invoiceList;
    state.lastFetchedInvoiceList = invoiceList;
  },
  [types.LOAD_MORE_CUSTOMERS](state, payload) {
    const customerList = [...state.lastFetchedCustomerList, ...payload];
    state.customerList = customerList;
    state.lastFetchedCustomerList = customerList;
  },
  [types.LOAD_MORE_VENDORS](state, payload) {
    const vendorList = [...state.lastFetchedVendorList, ...payload];
    state.vendorList = vendorList;
    state.lastFetchedVendorList = vendorList;
  },
  [types.CLONE_INVOICES](state, payload) {
    state.recentImportedInvoices = payload;
  },
  [types.SET_IMPORTED_INVOICES](state, payload) {
    state.recentImportedInvoices = payload;
  },
  [types.FILTER_INVOICES](state, payload) {
    let sourceList = [];
    // Apply remote search -> Get invoices from server regardless dir tag or status.
    if (payload.filterParams.searchText.length > 0) {
      sourceList = payload.invoices;
    } else {
      // Does not apply search get last fetch result;
      sourceList = state.lastFetchedInvoiceList;
    }

    if (payload.filterParams.type === 'ALL') {
      state.invoiceList = sourceList;
    } else if (payload.filterParams.type === 'INCOME') {
      state.invoiceList = sourceList.filter(i => !i.kind_of);
    } else if (payload.filterParams.type === 'PAID') {
      state.invoiceList = sourceList.filter(i => !!i.paid_date);
    } else if (
      payload.filterParams.type === 'INCOME&!PAID' ||
      payload.filterParams.type === 'OUTCOME&!PAID'
    ) {
      state.invoiceList = sourceList.filter(
        i =>
          !i.paid_date &&
          ((payload.filterParams.type === 'INCOME&!PAID' && !i.kind_of) ||
            (payload.filterParams.type === 'OUTCOME&!PAID' && i.kind_of)),
      );
    } else {
      state.invoiceList = sourceList.filter(i => i.kind_of);
    }
    // console.warn('filter invoices list');
    // console.warn(state.invoiceList);
  },
  [types.UPDATE_INVOICE](state, payload) {
    const index = state.invoiceList.findIndex(item => item.id === payload.id);
    if (index !== -1) {
      Vue.set(state.invoiceList, index, payload);
    }
  },
  [types.UPDATE_INVOICE_FIELD](state, { id, path, value }) {
    const index = state.invoiceList.findIndex(item => item.id === id);
    if (index !== -1) {
      const invoice = state.invoiceList[index];
      const parentPath = path.split('.').slice(0, -1).join('.');
      const key = path.split('.').pop();
      const parent = _.get(invoice, parentPath);
      if (parent && key) {
        Vue.set(parent, key, value);
      } else if (key) {
        Vue.set(invoice, key, value);
      }
    }
  },
  [types.SET_PAID_DATE](state, payload) {
    payload.forEach((paidItem) => {
      const index = state.invoiceList.findIndex(
        item => item.id === paidItem.id,
      );
      if (index !== -1) {
        Vue.set(state.invoiceList, index, paidItem);
      }
    });
  },
  // eslint-disable-next-line no-unused-vars
  [types.APPROVE_LIST_INVOICE](state, payload) {
    // state.invoiceList.unshift(payload);
  },
  [types.CREATE_INVOICE](state, payload) {
    state.invoiceList.unshift(payload);
  },
  [types.INVOICE_FILE_CHANGED](state, payload) {
    const file = parseInvoiceFile(payload);
    state.invoiceBase64File = file ? file.content : '';
  },
  [types.INVOICE_FILE_LOADING](state, payload) {
    state.invoiceFileLoading = payload;
  },
  [types.DETAILS_INVOICE_LOADING](state, payload) {
    state.detailsInvoiceLoading = payload;
  },
  [types.DOWNLOAD_INVOICE_LOADING](state, payload) {
    state.downloadInvoiceLoading = payload;
  },
  [types.DOWNLOAD_EXCEL_LOADING](state, payload) {
    state.downloadExcelLoading = payload;
  },
  [types.DOWNLOAD_XML_BCSS_LOADING](state, payload) {
    state.downloadXmlBcssLoading = payload;
  },
  [types.INVOICE_LIST_PAGE_INFO](state, payload) {
    state.invoiceListPageInfo = payload;
  },
  [types.INVOICE_LIST_LOADING](state, payload) {
    state.invoiceListLoading = payload;
  },
  [types.CUSTOMER_LIST_LOADING](state, payload) {
    state.customerListLoading = payload;
  },
  [types.VENDOR_LIST_LOADING](state, payload) {
    state.vendorListLoading = payload;
  },
  [types.SET_INVOICE_COUNT](state, payload) {
    const activeDirId = state.activeDirectory.id;
    state.invoiceCount[activeDirId] = payload;
  },
  [types.GET_TAGS](state, payload) {
    state.tags = payload;
    localStorage.setItem('tags', JSON.stringify(state.tags));
  },
  [types.GET_INVOICE_LIST_ENUM](state, payload) {
    state.invoiceListEnum = payload;
    localStorage.setItem('list-enum', JSON.stringify(state.invoiceListEnum));
  },
  [types.GET_INVOICE_COMMON_CODE](state, payload) {
    state.invoice_common_code = payload;
    localStorage.setItem('invoice_common_code', JSON.stringify(payload));
  },
  [types.GET_SELLER_SETTING_LIST](state, payload) {
    state.sellerSettingList = payload;
    localStorage.setItem('seller-setting-list', JSON.stringify(payload));
  },
  [types.GET_ACTIVE_ANNOUNCEMENT_LINES](state, payload) {
    const commons = {};
    const announcement = {};
    const result = payload.reduce((map, obj) => {
      if (!map[obj.template_type_obj.invoice_type]) {
        map[obj.template_type_obj.invoice_type] = [
          ...(map[obj.template_type_obj.invoice_type] || []),
          obj.template_type_obj.template_code,
        ];
      } else if (
        !map[obj.template_type_obj.invoice_type].find(
          x => x === obj.template_type_obj.template_code,
        )
      ) {
        map[obj.template_type_obj.invoice_type].push(
          obj.template_type_obj.template_code,
        );
      }

      commons[obj.template_type_obj.template_code] = [
        ...(commons[obj.template_type_obj.template_code] || []),
        obj.invoice_common_code,
      ];

      announcement[obj.invoice_common_code] = obj.annoucement_line_id;

      return map;
    }, {});

    const activeAnnouncementLines = {
      list_invoice_type: Object.keys(result),
      list_template_code: result,
      list_common_code: commons,
      list_template_announcement: announcement,
    };
    state.activeAnnouncementLines = activeAnnouncementLines;
    localStorage.setItem(
      'active-announcement-lines',
      JSON.stringify(activeAnnouncementLines),
    );
  },
  [types.GET_CACHED_SELLER_SETTING_LIST](state, payload) {
    state.sellerSettingList = payload;
  },
  [types.GET_CACHED_ACTIVE_ANNOUNCEMENT_LINES](state, payload) {
    state.activeAnnouncementLines = payload;
  },
  [types.DELETE_TAG](state, deletedTagId) {
    state.tags = state.tags.filter(tag => parseInt(tag.id, 10) !== parseInt(deletedTagId, 10));
    localStorage.setItem('tags', JSON.stringify(state.tags));
  },
  [types.CREATE_TAG](state, payload) {
    state.tags = [...state.tags, payload];
    localStorage.setItem('tags', JSON.stringify(state.tags));
  },
  [types.UPDATE_TAG](state, payload) {
    const idx = state.tags.findIndex(tag => parseInt(tag.id, 10) === parseInt(payload.id, 10));
    if (idx > -1) {
      state.tags[idx].name = payload.name;
    }
    state.tags = [...state.tags];
    localStorage.setItem('tags', JSON.stringify(state.tags));
  },
  [types.SET_TAG](state, payload) {
    const { tags, invoices } = payload;
    const invoiceSet = new Set(invoices);
    // eslint-disable-next-line no-console
    state.invoiceList = state.invoiceList.map((inv) => {
      // eslint-disable-next-line no-console
      if (invoiceSet.has(inv.id)) {
        if (inv.tags.length < tags.length) {
          const invTagsSet = new Set(inv.tags.map(t => parseInt(t.id, 10)));
          const uniqueTags = new Set(tags.filter(t => !invTagsSet.has(parseInt(t, 10))).map(t => parseInt(t, 10)));
          const tagsToAdd = state.tags.reduce((acc, tag) => {
            if (uniqueTags.has(parseInt(tag.id, 10))) {
              acc.push(tag);
            }
            return acc;
          }, []);
          inv.tags = [...inv.tags, ...tagsToAdd];
        } else {
          const listTagsInt = new Set(tags.map(t => parseInt(t, 10)));
          inv.tags = inv.tags.filter(t => listTagsInt.has(parseInt(t.id, 10)));
        }
      }
      return inv;
    });
    state.selectedInvoices = new Set();
  },
  [types.SET_STATE](state, payload) {
    Object.assign(state, payload);
    // Vue.set(state, k, payload[k]);
  },
  SET_AUTOCOMPLETE_OPTIONS(state, payload) {
    state.autoCompleteSearchResult = Object.assign(
      state.autoCompleteSearchResult,
      payload,
    );
  },
  SET_INVOICE_LIST_ENUM(state, payload) {
    state.invoiceListEnum = Object.assign(state.invoiceListEnum, payload);
  },
  [types.GET_IN_PROGRESS_INVOICES](state, payload) {
    state.inProgressInvoiceList = payload.invoices;
    // state.currentStatistic = getCurrentAppStatistics(payload);
  },
  [types.GET_APP_STATISTIC](state, payload) {
    state.appStatistics = payload;
  },
  [types.SET_CURRENT_STATISTIC](state, payload) {
    state.currentStatistic = payload;
  },
  [types.GET_INVOICES_STATISTIC](state, payload) {
    state.invoicesStatistic = {
      ...state.invoicesStatistic,
      ...payload,
    };
  },
  [types.GET_NOTIFICATIONS](state, payload) {
    state.notifications = {
      ...state.notifications,
      ...payload,
      page_info: {
        ...state.notifications.page_info,
        ...payload.page_info,
      },
    };
  },
  [types.GET_UNREAD_NOTIFICATIONS](state, payload) {
    state.unreadNotifications = {
      ...state.unreadNotifications,
      data: payload.data,
      page_info: {
        ...state.unreadNotifications.page_info,
        ...payload.page_info,
      },
    };
  },
  [types.LOAD_MORE_NOTIFICATIONS](state, payload) {
    state.notifications.data = [...state.notifications.data, ...payload.data];
    state.notifications.page_info = {
      ...state.notifications.page_info,
      ...payload.page_info,
    };
  },
  [types.LOAD_MORE_UNREAD_NOTIFICATIONS](state, payload) {
    state.unreadNotifications.data = [
      ...state.unreadNotifications.data,
      ...payload.data,
    ];
    state.unreadNotifications.page_info = {
      ...state.unreadNotifications.page_info,
      ...payload.page_info,
    };
  },
  [types.NOTIFICATIONS_LOADING](state, payload) {
    state.notificationsLoading = payload;
  },
  [types.MARK_READ_NOTIFICATION](state, payload) {
    const idsSet = new Set(payload);
    state.notifications.data = state.notifications.data.map((notification) => {
      if (idsSet.has(notification.id)) {
        notification.is_readed = true;
      }
      return notification;
    });
    state.unreadNotifications.data = state.unreadNotifications.data.filter(
      notification => !idsSet.has(notification.id),
    );
    state.unreadNotifications.page_info.total -= idsSet.size;
  },
  [types.SET_ERROR_INVOICES](state, payload) {
    state.inProgressErrorInvoices = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js